function isString(str: any): str is string {
  return typeof str === 'string';
}

export default isString;
